function SubMainTitleSkills({ title, subtitle }) {
    return (
        <div>
            <h2 className="skills__title">{title}</h2>
            <span className="skills__subtitle">{subtitle}</span>
        </div>
    );
}



export { SubMainTitleSkills };
